import { render } from "./androidDownloadInstructions.vue?vue&type=template&id=379aefce&scoped=true&ts=true"
import script from "./androidDownloadInstructions.vue?vue&type=script&lang=ts"
export * from "./androidDownloadInstructions.vue?vue&type=script&lang=ts"

import "./androidDownloadInstructions.vue?vue&type=style&index=0&id=379aefce&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379aefce"]])

export default __exports__